import {
  FORMULA_ONE_REGULAR_FONT_URL,
  STRIPE,
  TITILLIUM_WEB_FONT_URL,
} from '../constants/stripePayment.constant';
import { stripePaymentTypes } from '../subscriptionInfo/components/paymentMethodStripe/paymentTypes.constant';

export const stripeFonts = [
  {
    family: 'Formula1-Regular',
    src: `url(${FORMULA_ONE_REGULAR_FONT_URL}) format(woff)`,
    weight: '500',
  },
  {
    cssSrc: TITILLIUM_WEB_FONT_URL,
  },
];

export const stripeSelectedPaymentNames = {
  paypal: 'PayPal',
  google_pay: 'Google Pay',
  apple_pay: 'Apple Pay',
};

export const getStripePaymentList = (
  paymentInstrumentEntity,
  stripeListApiValues,
) => {
  if (!paymentInstrumentEntity) {
    return {
      nameOnCard: '',
      type: '',
      subType: '',
      accountType: '',
    };
  }
  if (paymentInstrumentEntity?.StripeAccount) {
    const { BillingAddress } = paymentInstrumentEntity;
    const { PaymentMethodSubType, PaymentMethodType } =
      paymentInstrumentEntity?.StripeAccount || {};
    return {
      nameOnCard: BillingAddress?.Name || '',
      type: STRIPE,
      subType: PaymentMethodSubType,
      accountType: PaymentMethodType,
    };
  }
  const nameOnCardValue =
    paymentInstrumentEntity?.CreditCard?.NameOnCard ||
    paymentInstrumentEntity?.NameOnCard ||
    '';
  if (stripeListApiValues) {
    const getValue = {
      nameOnCard: nameOnCardValue,
      type: STRIPE,
      subType: paymentInstrumentEntity?.Name?.split(' ')?.[0]?.toLowerCase(),
      accountType: stripePaymentTypes.CARD,
      isCreditCard: true,
    };
    return getValue;
  }

  const splitNameOnCard = nameOnCardValue?.split('-');
  const [nameOnCard, type, subType, accountType] = splitNameOnCard;
  return {
    nameOnCard,
    type,
    subType,
    accountType,
  };
};

export const debounce = (mainFunction, delay) => {
  let timer;
  return function (...args) {
    clearTimeout(timer);

    timer = setTimeout(() => {
      mainFunction(...args);
    }, delay);
  };
};
